import {useEffect, useState} from 'react';
import DisplayHelpers from '@/helpers/display_helpers';

function getTimeSince<T>(object: T, property: keyof T, short?: boolean) {
  return DisplayHelpers.timeSince(new Date(object[property] as string), short);
}

export function useTimeSince<T>(object: T, property: keyof T, short?: boolean) {
  const [timeSince, setTimeSince] = useState(getTimeSince(object, property, short));

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeSince(getTimeSince(object, property, short));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [object]);

  return timeSince;
}
